module.exports = __webpack_public_path__ + "img/arrow.242238d8.svg";